<template>
    <div class="min-h-screen flex justify-center items-center bg-white">
      <div class="bg-white p-8 rounded-xl shadow-md w-full sm:w-96">
        <h2 class="text-3xl font-semibold text-center text-gray-800 mb-6">Бүртгэлийн ажилтан</h2>

        <!-- Validation Error Messages -->
        <div v-if="errorMessage" class="text-red-500 text-center mb-4">{{ errorMessage }}</div>

        <form @submit.prevent="handleLogin" class="space-y-6">
          <div>
            <label for="phone1" class="block text-gray-700">Утасны дугаар</label>
            <input
              id="phone1"
              type="text"
              v-model="form.phone1"
              required
              :class="{'border-red-500': phone1Error}"
              class="w-full p-3 mt-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Утасны дугаараа оруулна уу"
              @blur="validatePhone1"
            />
            <!-- <span v-if="phone1Error" class="text-red-500 text-sm">Зөв утасны дугаар оруулна уу.</span> -->
          </div>

          <div>
            <label for="password" class="block text-gray-700">Нууц үг</label>
            <input
              id="password"
              type="password"
              v-model="form.password"
              required
              :class="{'border-red-500': passwordError}"
              class="w-full p-3 mt-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Нууц үгээ оруулна уу"
              @blur="validatePassword"
            />
          </div>

          <div>
            <button
              type="submit"
              :disabled="submitDisabled"
              class="w-full py-3 bg-pink-500 text-white rounded-md hover:bg-pink-600 transition duration-300 disabled:bg-gray-300"
            >
              Нэвтрэх
            </button>
          </div>
        </form>

        <div class="text-center mt-4">
          <p class="text-sm text-gray-600">Танд бүртгэлгүй юу? <router-link to="/register" class="text-pink-500">Бүртгүүлэх</router-link></p>
        </div>
      </div>
    </div>
  </template>

<script>
import services from '@/helpers/services'
import { mapActions } from 'vuex'

export default {
  name: 'LoginPage',
  data () {
    return {
      form: {
        phone1: '',
        password: ''
      },
      errorMessage: '',
      phone1Error: false,
      passwordError: false
    }
  },
  computed: {
    submitDisabled () {
      return this.phone1Error || this.passwordError
    }
  },
  methods: {
    ...mapActions(['setToken', 'setUser', 'setPermissions', 'setConfig']),

    validatePhone1 () {
      const digits = String(this.form.phone1 || '').replace(/\D/g, '')
      this.phone1Error = digits.length < 8
    },

    validatePassword () {
      const p = this.form.password || ''
      this.passwordError = p.length > 0 && p.length < 4
    },

    async handleLogin () {
      this.errorMessage = ''
      this.validatePhone1()
      this.validatePassword()
      if (this.phone1Error) {
        this.errorMessage = 'Утасны дугаарыг зөв оруулна уу (хамгийн багадаа 8 орон).'
        return
      }
      if (this.passwordError) {
        this.errorMessage = 'Нууц үг хамгийн багадаа 4 тэмдэгт байна.'
        return
      }

      // Validate form before API request
      if (!this.form.phone1 || !this.form.password) {
        this.errorMessage = 'Бүх талбаруудыг бөглөнө үү.'
        return
      }

      try {
        const response = await services.login(this.form)
        console.log('Нэвтрэх амжилттай:', response)
        if (response) {
          this.setToken(response.token)
          this.setUser(response.user)
          this.setPermissions(response.permissions)
          if (response.user.company_id === null) {
            this.setConfig(response.user.company_id)
          }
          this.$router.push('/trackcodes')
          window.location.reload()
        }
      } catch (error) {
        let msg =
          typeof error === 'string'
            ? error
            : error && error.message
              ? error.message
              : 'Нэвтрэхэд алдаа гарлаа'
        if (/Failed to fetch|NetworkError|ERR_CONNECTION|load failed|network/i.test(String(msg))) {
          msg =
            'Серверт холбогдож чадсангүй. `sky_cargo_back` хавтаснаас `npm start` (порт 3000) асаасан эсэхийг шалгана уу.'
        }
        this.errorMessage = msg
      }
    }
  }
}
</script>

  <style scoped>
  body {
    margin: 0;
    font-family: 'Arial', sans-serif;
  }
  </style>
